import { render, staticRenderFns } from "./AddTransfer.vue?vue&type=template&id=60449371&scoped=true&"
import script from "./AddTransfer.vue?vue&type=script&lang=ts&"
export * from "./AddTransfer.vue?vue&type=script&lang=ts&"
import style0 from "./AddTransfer.vue?vue&type=style&index=0&id=60449371&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60449371",
  null
  
)

export default component.exports